import { createSlice } from "@reduxjs/toolkit";
import { getItem, setItem } from "../utils/localStorageUtil";

const initialState = {
  country: "gl",
  language: "en",
  env: "prod",
  consentAccepted: getItem('consentAccepted') === true,
};

const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setConsentAccepted(state, action) {
      console.log("[DEBUG Consent Flow] Redux Action setConsentAccepted Payload:", action.payload);
      state.consentAccepted = action.payload;
      setItem('consentAccepted', action.payload);
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setEnv: (state, action) => {
      state.env = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setCountry, setLanguage, setEnv, setConsentAccepted } = generalSlice.actions;
export default generalSlice.reducer;
